module.exports = __webpack_public_path__ + "img/crypto-seed-phrase-storage_B096J1G94W.1c5135b3.jpg";